// Teams deep link sub page ids look like "analysisOrder/<uuid>" or "analysisResult/<uuid>".
// Only whitelisted types are mapped to routes; anything else is ignored.
const DEEP_LINK_ROUTES: Record<string, (uuid: string) => string> = {
  analysisOrder: (uuid) => `/Oi/analysisOrder/${encodeURIComponent(uuid)}`,
  analysisResult: (uuid) => `/Oi/analysisResult/${encodeURIComponent(uuid)}`,
};

export function resolveOiDeepLinkRoute(subPageId: string | undefined | null): string | null {
  if (!subPageId) return null;

  const separator = subPageId.indexOf("/");
  if (separator <= 0) return null;

  const type = subPageId.slice(0, separator);
  const uuid = subPageId.slice(separator + 1);
  if (!uuid || uuid.includes("/")) return null;
  if (!Object.prototype.hasOwnProperty.call(DEEP_LINK_ROUTES, type)) return null;

  return DEEP_LINK_ROUTES[type](uuid);
}
